export default "__VITE_ASSET__BeAoLfVH__"